// Mesma regra do backend (lib/senha.js) — duplicada de propósito: aqui é só
// feedback visual enquanto digita, quem valida de verdade é o servidor.
export interface RegraSenha {
  label: string;
  testar: (s: string) => boolean;
}

export const REGRAS_SENHA: RegraSenha[] = [
  { label: "Pelo menos 8 caracteres", testar: (s) => s.length >= 8 },
  { label: "1 letra minúscula", testar: (s) => /[a-z]/.test(s) },
  { label: "1 letra maiúscula", testar: (s) => /[A-Z]/.test(s) },
  { label: "1 número", testar: (s) => /[0-9]/.test(s) },
  { label: "1 símbolo (! @ # $ ...)", testar: (s) => /[^A-Za-z0-9]/.test(s) },
];

export const senhaForte = (s: string) => REGRAS_SENHA.every((r) => r.testar(s));
